import { render, staticRenderFns } from "./ToggleViewButton.vue?vue&type=template&id=654952e5"
import script from "./ToggleViewButton.vue?vue&type=script&lang=js"
export * from "./ToggleViewButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports